import { Skeleton } from '@anytag/shared-atoms';
import { ChatHistoryProps } from './types';
import { ChatHistoryItem } from './chat-history-item';
import { useEditingHistoryName, useFetchHistory, initialEditingNameState } from './hooks';

export const ChatHistory = (props: ChatHistoryProps) => {
  const { allGeminiChats, loading, chatBottomRef, containerRef } = useFetchHistory();
  const { editingName, setEditingName, handleUpdateName } = useEditingHistoryName();

  if (loading) return <ChatHistorySkeleton />;

  return (
    <div className="grid gap-1 overflow-y-auto px-4 py-6 text-base" ref={containerRef}>
      {allGeminiChats.map((chat, i) => (
        <ChatHistoryItem
          {...props}
          key={chat.id}
          chat={chat}
          isCurrent={props.threadId === chat.id}
          editingName={editingName.id === chat.id ? editingName : initialEditingNameState}
          setEditingName={setEditingName}
          onUpdateName={handleUpdateName}
        />
      ))}
      <div ref={chatBottomRef} />
    </div>
  );
};

export const ChatHistorySkeleton = () => (
  <div className="grid gap-2 px-4 py-6 text-base">
    {Array.from({ length: 10 }).map((_, index) => (
      <Skeleton key={index} className="h-10 w-full rounded-sm bg-black-30" />
    ))}
  </div>
);
